import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import axios from 'axios'

Vue.use(Router)
let router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/Profile',
			name: 'Profile',
			component: () => import('../components/Common/AppProfile'),
			meta: {
				description: 'Application User Profile Page',
				requiresAuth: true
			}
		},
		{
			path: '/',
			name: 'Home',
			props: true,
			component: () => import('../components/Common/AppHome'),
			meta: {
				description: 'Home Page',
			}
		},
		{
			path: '/Signup',
			name: 'Signup',
			component: () => import('../components/Common/AppSignup'),
			meta: {
				description: 'Signup Page',
			}
		},
		{
			path: '/Login',
			name: 'Login',
			component: () => import('../components/Common/AppLogin'),
			meta: {
				description: 'Login Page',
			}
		},
		{
			path: '/CompleteProfile',
			name: 'CompleteProfile',
			component: () => import('../components/Login/loginCompleteProfile'),
			meta: {
				description: 'Complete Profile Page',
				requiresAuth: true
			},
		},
		{
			path: '/DocumentsUpload',
			name: 'DocumentsUpload',
			component: () => import('../components/Login/documents'),
			meta: {
				description: 'Documents Upload Page',
				requiresAuth: true
			},
		},
		{
			path: '/RegistrationAcknowledgement',
			name: 'RegistrationAcknowledgement',
			component: () => import('../components/Login/registrationAcknowledgement'),
			meta: {
				description: 'Registration Acknowledgement Page',
				requiresAuth: true
			},
		},
		{
			path: '/BankDetails',
			name: 'BankDetails',
			component: () => import('../components/Login/bankDetails'),
			meta: {
				description: 'Bank Details Page',
				requiresAuth: true
			},
		},
		{
			path: '/CompleteProfileSuccess',
			name: 'CompleteProfileSuccess',
			component: () => import('../components/Login/completProfileSuccess'),
			meta: {
				description: 'Complete Profile Success Page',
				requiresAuth: true
			}
		},
		{
			path: '/ForgotPassword',
			name: 'ForgotPassword',
			component: () => import('../components/Common/AppForgotPassword'),
			meta: {
				description: 'Password Reset Page',
				requiresAuth: false
			}
		},
		{
			path: '/TermsAndConditions',
			name: 'TermsAndConditions',
			props: true,
			component: () => import('../components/Common/AppTermsAndConditions'),
			meta: {
				description: 'App Terms And Conditions Page',
			}
		},
		{
			path: '/InvestmentRisks',
			name: 'InvestmentRisks',
			props: true,
			component: () => import('../components/Common/AppInvestmentRisks'),
			meta: {
				description: 'App Investment Risks Page',
			}
		},
		{
			path: '/BusinessContinuity',
			name: 'BusinessContinuity',
			props: true,
			component: () => import('../components/Common/AppBusinessContinuity'),
			meta: {
				description: 'App Business Continuity Page',
			}
		},
		{
			path: '/EmailVerified/:id/:authcode',
			name: 'EmailVerified',
			component: () => import('../components/Signup/EmailVerified'),
			props: true,
			meta: {
				description: 'Email Verified Page',
			}
		},
		{
			path: '/Forgot_Password/:authcode/:id',
			name: 'Forgot_Password',
			component: () => import('../components/Password/newPassword'),
			props: true,
			meta: {
				description: 'Password Reset Page',
				requiresAuth: false
			}
		},
		{
			path: '/Timeout',
			name: 'Timeout',
			component: () => import('../components/Common/AppTimeout'),
			meta: {
				description: 'App Timeout Page',
				requiresAuth: false
			}
		},
		{
			path: '/Query',
			name: 'Query',
			component: () => import('../components/Common/AppQuery'),
			meta: {
				description: 'App Query Page',
				requiresAuth: false
			}
		},
		{
			path: '/QuerySuccess',
			name: 'QuerySuccess',
			component: () => import('../components/Common/AppQuerySuccess'),
			meta: {
				description: 'App Query Success Page',
				requiresAuth: false
			}
		},
		{
			path: '/Project/:id',
			name: 'Project',
			props: true,
			component: () => import('../components/Common/AppProject'),
			meta: {
				description: 'App Project View Page',
				requiresAuth: true
			}
		},
		{
			path: '/Project/:id/Invest',
			name: 'ProjectInvest',
			props: true,
			component: () => import('../components/Common/AppInvest'),
			meta: {
				description: 'App Project Invest Page',
				requiresAuth: true
			}
		},
		{
			path: '/ProjectStatus',
			name: 'ProjectStatus',
			component: () => import('../components/Common/AppProjectStatus'),
			meta: {
				description: 'App Project Status Page',
				requiresAuth: true
			}
		},
		{
			path: '/AboutUs',
			name: 'AboutUs',
			component: () => import('../components/Common/AppAboutUs'),
			meta: {
				description: 'App About Us Page',
				requiresAuth: false
			}
		},
		{
			path: '/Settings',
			name: 'Settings',
			component: () => import('../components/Common/AppSettings'),
			meta: {
				description: 'App Settings Page',
				requiresAuth: true
			}
		},
		{
			path: '/ChangePassword',
			name: 'ChangePassword',
			component: () => import('../components/Settings/changePassword'),
			meta: {
				description: 'App Change Password Page',
				requiresAuth: true
			}
		},
		{
			path: '/KYC',
			name: 'KYC',
			component: () => import('../components/Settings/KYC'),
			meta: {
				description: 'App KYC Page',
				requiresAuth: true
			}
		},
		{
			path: '/Bank',
			name: 'Bank',
			component: () => import('../components/Settings/Bank'),
			meta: {
				description: 'App Bank Page',
				requiresAuth: true
			}
		},
		{
			path: '/Resources',
			name: 'Resources',
			props: true,
			component: () => import('../components/Common/AppResources'),
			meta: {
				description: 'App Resources Page',
				requiresAuth: false
			}
		},
		{
			path: '/Blog/:id',
			name: 'Blog',
			props: true,
			component: () => import('../components/Common/AppBlog'),
			meta: {
				description: 'App Blog Page',
				requiresAuth: false
			}
		},
		{
			path: '/Blog/Filter/:type/:id',
			name: 'BlogFilter',
			props: true,
			component: () => import('../components/Resources/filterBlog'),
			meta: {
				description: 'App Blog Filter Page',
				requiresAuth: false
			}
		},
		{
			path: '/001',
			name: 'UserRemove',
			props: true,
			component: () => import('../components/Common/001'),
			meta: {
				description: 'User Remove Page',
				requiresAuth: false
			}
		},
		{
			path: '*',
			name: 'NotFound',
			props: true,
			component: () => import('../components/Common/404'),
			meta: {
				description: 'App 404 Page',
				requiresAuth: false
			}
		},
		{
			path: '/ServerError',
			name: 'ServerError',
			props: true,
			component: () => import('../components/Common/500'),
			meta: {
				description: 'App Server Error Page',
				requiresAuth: false
			}
		},
	],
	scrollBehavior() {
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0;
	},
})
router.beforeEach((to, from, next) => {
	axios({
		method: 'POST',
		url: '/log/navigate',
		headers: {
			'x-auth-token': localStorage.getItem('token')
		},
		params: {
			pagename: to.name,
			description: to.meta.description
		}
	})
	if (to.matched.some(route => route.name && store.state.isLoggedIn)) {
		axios({
			method: 'POST',
			url: '/validate/token',
			headers: {
				'x-auth-token': localStorage.getItem('token')
			}
		}).then(response => {
			if (!response.data.status) {
				store.commit("sessionOut", true);
				next({
					path: '/Timeout',
				})
				return
			}
		})
			.catch(err => {
				this.msg = err;
				// this.$router.push("/ServerError");
			});
	}
	if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
		next({ name: 'Login' })
		return
	}
	next()
})

export default router